<div [formGroup]="companionForm()" class="flex flex-col gap-4">
  <div>
    {{
      textStore.texts()
        | filterTexts: ERelationType.passengerData : EEntityType.directTicket
        | language
    }}
  </div>
  @if (auth.isLoggedIn() && fellowTravelers().length > 0) {
    <aw-drop-down
      [id]="'fellow-traveler-' + companionIndex() | appendTestId: id()"
      formControlName="fellowTravelerId"
      [label]="
        textStore.texts()
          | filterTexts
            : ERelationType.loadPassengerData
            : EEntityType.generalArea
          | language
      "
      [options]="fellowTravelerOptions()"
      name="label"
      [showResetIcon]="true"
      valueAttribute="value">
    </aw-drop-down>
  }
  <aw-text-input
    formControlName="firstName"
    [label]="
      textStore.texts()
        | filterTexts
          : ERelationType.newCustomerFirstName
          : EEntityType.generalArea
        | language
    "
    [id]="
      'ticket-companion-first-name-' + companionIndex() | appendTestId: id()
    "></aw-text-input>
  <aw-text-input
    formControlName="lastName"
    [label]="
      textStore.texts()
        | filterTexts
          : ERelationType.newCustomerLastName
          : EEntityType.generalArea
        | language
    "
    [id]="
      'ticket-companion-last-name-' + companionIndex() | appendTestId: id()
    "></aw-text-input>
</div>
